import genericFields from '../resource/generic-fields'
import articlesRelatedToEntity from '../author/articles-related-to-entity'
import { companyPortalQueries } from '@/query/company/render-company'
import { companyImageFields } from './lib/company-query-fragments'

const createQuery = () => {
  return `query AllCompanyArticles($url: String!, $type: String!, $contentType: String, $page: Int = 1) {
    ${genericFields()}
    resource(url:$url) {
      __typename
      ...on Company {
        _id
        name
        slug
        ${companyImageFields}
        ${companyPortalQueries.Company}
      }
    }
    ${articlesRelatedToEntity()}
  }`
}

export default createQuery
